import script from "./ClassicCore.vue?vue&type=script&lang=js"
export * from "./ClassicCore.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__